import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {catchError, map, Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {GoogleMap, MapInfoWindow, MapMarker} from "@angular/google-maps";
import {GetMapPointersCB} from "../../Ope/Map/GetMapPointersCB";
import {MapService} from "../../Services/Ope/Map.service";
import {MapPointer} from "../../Models/Map/MapPointer";
import {MatTableDataSource} from "@angular/material/table";
import {CustomerDevice} from "../../Models/CustomerDevice/CustomerDevice";
import {BaseComponent} from "../common/BaseComponent";

@Component({
  selector: 'app-publicMap',
  templateUrl: './publicMap.component.html',
  styleUrls: ['./publicMap.component.css']
})
export class PublicMapComponent extends BaseComponent implements OnInit {

  options: google.maps.MapOptions = {
    mapTypeId: 'roadmap',
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: true,
    minZoom: 6,
    fullscreenControl: true,
    streetViewControl: false,
    mapTypeControl: false
  };

  mapOk = false;
  initialLoading = true;

  mapBounds?: google.maps.LatLngBounds;

  pointers?: MapPointer[];
  selectedPointer?: MapPointer;

  // MAP PARAMETERS
  @ViewChild(GoogleMap, {static: false}) map?: GoogleMap;
  @ViewChild(MapInfoWindow, {static: false}) infoWindow?: MapInfoWindow;

  private mapService = inject(MapService);

  ngOnInit(): void {
    this.initializeMap();
  }

  tryFitBoundsToMarkers() {
    if (this.initialLoading) {
      this.initialLoading = false;
      this.fitBoundsToMarkers();
    }
  }

  fitBoundsToMarkers() {
    if (!!this.map && !!this.mapBounds) {
      this.map.fitBounds(this.mapBounds); // map should be your map class
    }
    this.mapOk = true;
  }

  openInfo(entity: MapPointer, mapMarker: MapMarker) {
    this.selectedPointer = entity;
    if (!!this.infoWindow) {
      this.infoWindow.open(mapMarker);
    }
  }


  initializeMap() {
    this.pointers = [];
    const cb = new GetMapPointersCB();

    this.mapService.getMapPointers(cb).subscribe(
      () => {
        this.mapBounds = new google.maps.LatLngBounds();
        cb.o.mapPointers.forEach(pointer => {
          try{
            this.mapBounds!.extend(pointer.position);
          } catch {
            return;
          }
          pointer.options = this.setMarkerOptions(pointer);
          pointer.options.optimized = true;
          this.pointers?.push(pointer);

        })
        this.tryFitBoundsToMarkers();
      }, (error: string) => {
        this.gmService.openErrorSnackbar(error);
        this.mapOk = true;
      }
    )

  }

  setMarkerOptions(marker: MapPointer) {

    let icon = 'assets/markers/';

    if (marker.entityType === "ASSET") {
      icon = icon + 'AssetActive.png';
    } else if (marker.entityType === "DEVICE") {
      if (!marker.active) {
        icon = icon + 'EntityNotActive.png';
      } else {
        icon = icon + 'DeviceActive.png';
      }
    }
    return {
      icon: icon
    }
  }

  assignColor(selectedPointer: MapPointer) {
    let style = "color: "
    if (selectedPointer.active) {
      return style + "green";
    } else {
      return style + "yellow";
    }
  }
}
